// AUTO-GENERATED FILE - DO NOT EDIT
// This file was automatically generated by the XDK build tool.
// Any manual changes will be overwritten on the next generation.

/**
 * spaces client for the X API.
 *
 * This module provides a client for interacting with the spaces endpoints of the X API.
 */

import { Client, ApiResponse, RequestOptions } from '../client.js';
import { 
    Paginator, 
    PostPaginator, 
    UserPaginator, 
    EventPaginator
} from '../paginator.js';
import {
GetByIdsResponse,
GetBuyersResponse,
GetPostsResponse,
SearchResponse,
GetByIdResponse,
GetByCreatorIdsResponse,
} from './models.js';


/**
 * Options for getByIds method
 * 
 * @public
 */
export interface GetByIdsOptions {
    
    
    /** A comma separated list of Space fields to display. 
     * Also accepts: space.fields or proper camelCase (e.g., spaceFields) */
    spaceFields?: Array<any>;
    
    
    
    /** A comma separated list of fields to expand. 
     * Also accepts: expansions or proper camelCase (e.g., expansions) */
    expansions?: Array<any>;
    
    
    
    /** A comma separated list of User fields to display. 
     * Also accepts: user.fields or proper camelCase (e.g., userFields) */
    userFields?: Array<any>;
    
    
    
    /** A comma separated list of Topic fields to display. 
     * Also accepts: topic.fields or proper camelCase (e.g., topicFields) */
    topicFields?: Array<any>;
    
    
    
    /** Additional request options */
    requestOptions?: RequestOptions;
    /** Allow original API parameter names (e.g., 'tweet.fields', 'user.fields') and proper camelCase (e.g., 'tweetFields', 'userFields') */
    [key: string]: any;
}


/**
 * Options for getBuyers method
 * 
 * @public
 */
export interface GetBuyersOptions {
    
    
    /** This parameter is used to get a specified 'page' of results. 
     * Also accepts: pagination_token or proper camelCase (e.g., paginationToken) */
    paginationToken?: any;
    
    
    
    /** The maximum number of results. 
     * Also accepts: max_results or proper camelCase (e.g., maxResults) */
    maxResults?: number;
    
    
    
    /** A comma separated list of User fields to display. 
     * Also accepts: user.fields or proper camelCase (e.g., userFields) */
    userFields?: Array<any>;
    
    
    
    /** A comma separated list of fields to expand. 
     * Also accepts: expansions or proper camelCase (e.g., expansions) */
    expansions?: Array<any>;
    
    
    
    /** A comma separated list of Tweet fields to display. 
     * Also accepts: tweet.fields or proper camelCase (e.g., tweetFields) */
    tweetFields?: Array<any>;
    
    
    
    /** Additional request options */
    requestOptions?: RequestOptions;
    /** Allow original API parameter names (e.g., 'tweet.fields', 'user.fields') and proper camelCase (e.g., 'tweetFields', 'userFields') */
    [key: string]: any;
}


/**
 * Options for getPosts method
 * 
 * @public
 */
export interface GetPostsOptions {
    
    
    /** The number of Posts to fetch from the provided space. If not provided, the value will default to the maximum of 100. 
     * Also accepts: max_results or proper camelCase (e.g., maxResults) */
    maxResults?: number;
    
    
    
    /** A comma separated list of Tweet fields to display. 
     * Also accepts: tweet.fields or proper camelCase (e.g., tweetFields) */
    tweetFields?: Array<any>;
    
    
    
    /** A comma separated list of fields to expand. 
     * Also accepts: expansions or proper camelCase (e.g., expansions) */
    expansions?: Array<any>;
    
    
    
    /** A comma separated list of Media fields to display. 
     * Also accepts: media.fields or proper camelCase (e.g., mediaFields) */
    mediaFields?: Array<any>;
    
    
    
    /** A comma separated list of Poll fields to display. 
     * Also accepts: poll.fields or proper camelCase (e.g., pollFields) */
    pollFields?: Array<any>;
    
    
    
    /** A comma separated list of User fields to display. 
     * Also accepts: user.fields or proper camelCase (e.g., userFields) */
    userFields?: Array<any>;
    
    
    
    /** A comma separated list of Place fields to display. 
     * Also accepts: place.fields or proper camelCase (e.g., placeFields) */
    placeFields?: Array<any>;
    
    
    
    /** Additional request options */
    requestOptions?: RequestOptions;
    /** Allow original API parameter names (e.g., 'tweet.fields', 'user.fields') and proper camelCase (e.g., 'tweetFields', 'userFields') */
    [key: string]: any;
}


/**
 * Options for search method
 * 
 * @public
 */
export interface SearchOptions {
    
    
    /** The state of Spaces to search for. 
     * Also accepts: state or proper camelCase (e.g., state) */
    state?: string;
    
    
    
    /** The number of results to return. 
     * Also accepts: max_results or proper camelCase (e.g., maxResults) */
    maxResults?: number;
    
    
    
    /** A comma separated list of Space fields to display. 
     * Also accepts: space.fields or proper camelCase (e.g., spaceFields) */
    spaceFields?: Array<any>;
    
    
    
    /** A comma separated list of fields to expand. 
     * Also accepts: expansions or proper camelCase (e.g., expansions) */
    expansions?: Array<any>;
    
    
    
    /** A comma separated list of User fields to display. 
     * Also accepts: user.fields or proper camelCase (e.g., userFields) */
    userFields?: Array<any>;
    
    
    
    /** A comma separated list of Topic fields to display. 
     * Also accepts: topic.fields or proper camelCase (e.g., topicFields) */
    topicFields?: Array<any>;
    
    
    
    /** Additional request options */
    requestOptions?: RequestOptions;
    /** Allow original API parameter names (e.g., 'tweet.fields', 'user.fields') and proper camelCase (e.g., 'tweetFields', 'userFields') */
    [key: string]: any;
}


/**
 * Options for getById method
 * 
 * @public
 */
export interface GetByIdOptions {
    
    
    /** A comma separated list of Space fields to display. 
     * Also accepts: space.fields or proper camelCase (e.g., spaceFields) */
    spaceFields?: Array<any>;
    
    
    
    /** A comma separated list of fields to expand. 
     * Also accepts: expansions or proper camelCase (e.g., expansions) */
    expansions?: Array<any>;
    
    
    
    /** A comma separated list of User fields to display. 
     * Also accepts: user.fields or proper camelCase (e.g., userFields) */
    userFields?: Array<any>;
    
    
    
    /** A comma separated list of Topic fields to display. 
     * Also accepts: topic.fields or proper camelCase (e.g., topicFields) */
    topicFields?: Array<any>;
    
    
    
    /** Additional request options */
    requestOptions?: RequestOptions;
    /** Allow original API parameter names (e.g., 'tweet.fields', 'user.fields') and proper camelCase (e.g., 'tweetFields', 'userFields') */
    [key: string]: any;
}


/**
 * Options for getByCreatorIds method
 * 
 * @public
 */
export interface GetByCreatorIdsOptions {
    
    
    /** A comma separated list of Space fields to display. 
     * Also accepts: space.fields or proper camelCase (e.g., spaceFields) */
    spaceFields?: Array<any>;
    
    
    
    /** A comma separated list of fields to expand. 
     * Also accepts: expansions or proper camelCase (e.g., expansions) */
    expansions?: Array<any>;
    
    
    
    /** A comma separated list of User fields to display. 
     * Also accepts: user.fields or proper camelCase (e.g., userFields) */
    userFields?: Array<any>;
    
    
    
    /** A comma separated list of Topic fields to display. 
     * Also accepts: topic.fields or proper camelCase (e.g., topicFields) */
    topicFields?: Array<any>;
    
    
    
    /** Additional request options */
    requestOptions?: RequestOptions;
    /** Allow original API parameter names (e.g., 'tweet.fields', 'user.fields') and proper camelCase (e.g., 'tweetFields', 'userFields') */
    [key: string]: any;
}



/**
 * Client for spaces operations
 * 
 * This client provides methods for interacting with the spaces endpoints
 * of the X API. It handles authentication, request formatting, and response
 * parsing for all spaces related operations.
 * 
 * @category spaces
 */
export class SpacesClient {
    private client: Client;

    /**
     * Creates a new spaces client instance
     * 
     * @param client - The main X API client instance
     */
    constructor(client: Client) {
        this.client = client;
    }

    /**
     * Normalize options object to handle both camelCase and original API parameter names
     * Only accepts: proper camelCase (tweetFields) and original API format (tweet.fields)
     */
    private _normalizeOptions<T extends Record<string, any>>(options: T, paramMappings: Record<string, string>): T {
        if (!options || typeof options !== 'object') {
            return options;
        }
        
        const normalized: any = { ...options };
        
        // For each parameter mapping (original -> proper camelCase)
        for (const [originalName, camelName] of Object.entries(paramMappings)) {
            // Check if original format is used (e.g., 'tweet.fields', 'tweet_fields')
            if (originalName in normalized && !(camelName in normalized)) {
                normalized[camelName] = normalized[originalName];
                delete normalized[originalName];
            }
            // Also check for proper camelCase (e.g., 'tweetFields')
            // If it's already in proper camelCase, keep it (no conversion needed)
            // The camelName is already the proper camelCase format
        }
        
        return normalized as T;
    }



  /**
   * Get Spaces by IDs
   * Retrieves details of multiple Spaces by their IDs.



   * @param ids The list of Space IDs to return.



   * @returns {Promise<GetByIdsResponse>} Promise resolving to the API response
   */
    // Overload 1: Default behavior (unwrapped response)
    async getByIds(
        
        
        
        
        
        ids: Array<any>,
        
        
        
        
        
        
        options: GetByIdsOptions = {}
        
    ): Promise<GetByIdsResponse> {
        // Normalize options to handle both camelCase and original API parameter names
        
        
        const paramMappings: Record<string, string> = {
            
            
            'space.fields': 'spaceFields',
            
            
            
            
            
            'user.fields': 'userFields',
            
            
            
            'topic.fields': 'topicFields',
            
            
        };
        const normalizedOptions = this._normalizeOptions(options || {}, paramMappings);
        
        
        // Destructure options (exclude path parameters, they're already function params)
        const {
            
            
            spaceFields = [],
            
            
            
            expansions = [],
            
            
            
            userFields = [],
            
            
            
            topicFields = [],
            
            
            
            requestOptions: requestOptions = {}
        } = normalizedOptions;
        

        // Build the path with path parameters
        let path = '/2/spaces';
        

        // Build query parameters
        const params = new URLSearchParams();
        
        
        
        
        if (ids !== undefined && ids.length > 0) {
            
            params.append('ids', ids.join(','));
            
        }
        
        
        
        
        
        
        if (spaceFields !== undefined && spaceFields.length > 0) {
            
            params.append('space.fields', spaceFields.join(','));
            
        }
        
        
        
        
        
        
        if (expansions !== undefined && expansions.length > 0) {
            
            params.append('expansions', expansions.join(','));
            
        }
        
        
        
        
        
        
        if (userFields !== undefined && userFields.length > 0) {
            
            params.append('user.fields', userFields.join(','));
            
        }
        
        
        
        
        
        
        if (topicFields !== undefined && topicFields.length > 0) {
            
            params.append('topic.fields', topicFields.join(','));
            
        }
        
        
        

        // Prepare request options
        const finalRequestOptions: RequestOptions = {
            
            
            // Pass security requirements for smart auth selection
            security: [
                
                {
                    
                    'BearerToken': [],
                    
                },
                
                {
                    
                    'OAuth2UserToken': ['space.read', 'tweet.read', 'users.read'],
                    
                }
                
            ],
            
            
            ...requestOptions
            
        };

        return this.client.request<GetByIdsResponse>(
            'GET',
            path + (params.toString() ? `?${params.toString()}` : ''),
            finalRequestOptions
        );
    }




  /**
   * Get Space ticket buyers
   * Retrieves a list of Users who purchased tickets to a specific Space by its ID.


   * @param id The ID of the Space to be retrieved.




   * @returns {Promise<GetBuyersResponse>} Promise resolving to the API response
   */
    // Overload 1: Default behavior (unwrapped response)
    async getBuyers(
        
        
        
        id: string,
        
        
        
        
        
        
        
        
        options: GetBuyersOptions = {}
        
    ): Promise<GetBuyersResponse> {
        // Normalize options to handle both camelCase and original API parameter names
        
        
        const paramMappings: Record<string, string> = {
            
            
            'pagination_token': 'paginationToken',
            
            
            
            'max_results': 'maxResults',
            
            
            
            'user.fields': 'userFields',
            
            
            
            
            
            'tweet.fields': 'tweetFields',
            
            
        };
        const normalizedOptions = this._normalizeOptions(options || {}, paramMappings);
        
        
        // Destructure options (exclude path parameters, they're already function params)
        const {
            
            
            paginationToken = undefined,
            
            
            
            maxResults = undefined,
            
            
            
            userFields = [],
            
            
            
            expansions = [],
            
            
            
            tweetFields = [],
            
            
            
            requestOptions: requestOptions = {}
        } = normalizedOptions;
        

        // Build the path with path parameters
        let path = '/2/spaces/{id}/buyers';
        
        
        path = path.replace('{id}', encodeURIComponent(String(id)));
        
        

        // Build query parameters
        const params = new URLSearchParams();
        
        
        
        
        if (paginationToken !== undefined) {
            
            params.append('pagination_token', String(paginationToken));
            
        }
        
        
        
        
        
        
        if (maxResults !== undefined) {
            
            params.append('max_results', String(maxResults));
            
        }
        
        
        
        
        
        
        if (userFields !== undefined && userFields.length > 0) {
            
            params.append('user.fields', userFields.join(','));
            
        }
        
        
        
        
        
        
        if (expansions !== undefined && expansions.length > 0) {
            
            params.append('expansions', expansions.join(','));
            
        }
        
        
        
        
        
        
        if (tweetFields !== undefined && tweetFields.length > 0) {
            
            params.append('tweet.fields', tweetFields.join(','));
            
        }
        
        
        

        // Prepare request options
        const finalRequestOptions: RequestOptions = {
            
            
            // Pass security requirements for smart auth selection
            security: [
                
                {
                    
                    'OAuth2UserToken': ['space.read', 'tweet.read', 'users.read'],
                    
                }
                
            ],
            
            
            ...requestOptions
            
        };

        return this.client.request<GetBuyersResponse>(
            'GET',
            path + (params.toString() ? `?${params.toString()}` : ''),
            finalRequestOptions
        );
    }




  /**
   * Get Space Posts
   * Retrieves a list of Posts shared in a specific Space by its ID.


   * @param id The ID of the Space to be retrieved.




   * @returns {Promise<GetPostsResponse>} Promise resolving to the API response
   */
    // Overload 1: Default behavior (unwrapped response)
    async getPosts(
        
        
        
        id: string,
        
        
        
        
        
        
        
        
        options: GetPostsOptions = {}
        
    ): Promise<GetPostsResponse> {
        // Normalize options to handle both camelCase and original API parameter names
        
        
        const paramMappings: Record<string, string> = {
            
            
            'max_results': 'maxResults',
            
            
            
            'tweet.fields': 'tweetFields',
            
            
            
            
            
            'media.fields': 'mediaFields',
            
            
            
            'poll.fields': 'pollFields',
            
            
            
            'user.fields': 'userFields',
            
            
            
            'place.fields': 'placeFields',
            
            
        };
        const normalizedOptions = this._normalizeOptions(options || {}, paramMappings);
        
        
        // Destructure options (exclude path parameters, they're already function params)
        const {
            
            
            maxResults = undefined,
            
            
            
            tweetFields = [],
            
            
            
            expansions = [],
            
            
            
            mediaFields = [],
            
            
            
            pollFields = [],
            
            
            
            userFields = [],
            
            
            
            placeFields = [],
            
            
            
            requestOptions: requestOptions = {}
        } = normalizedOptions;
        

        // Build the path with path parameters
        let path = '/2/spaces/{id}/tweets';
        
        
        path = path.replace('{id}', encodeURIComponent(String(id)));
        
        

        // Build query parameters
        const params = new URLSearchParams();
        
        
        
        
        if (maxResults !== undefined) {
            
            params.append('max_results', String(maxResults));
            
        }
        
        
        
        
        
        
        if (tweetFields !== undefined && tweetFields.length > 0) {
            
            params.append('tweet.fields', tweetFields.join(','));
            
        }
        
        
        
        
        
        
        if (expansions !== undefined && expansions.length > 0) {
            
            params.append('expansions', expansions.join(','));
            
        }
        
        
        
        
        
        
        if (mediaFields !== undefined && mediaFields.length > 0) {
            
            params.append('media.fields', mediaFields.join(','));
            
        }
        
        
        
        
        
        
        if (pollFields !== undefined && pollFields.length > 0) {
            
            params.append('poll.fields', pollFields.join(','));
            
        }
        
        
        
        
        
        
        if (userFields !== undefined && userFields.length > 0) {
            
            params.append('user.fields', userFields.join(','));
            
        }
        
        
        
        
        
        
        if (placeFields !== undefined && placeFields.length > 0) {
            
            params.append('place.fields', placeFields.join(','));
            
        }
        
        
        

        // Prepare request options
        const finalRequestOptions: RequestOptions = {
            
            
            // Pass security requirements for smart auth selection
            security: [
                
                {
                    
                    'BearerToken': [],
                    
                },
                
                {
                    
                    'OAuth2UserToken': ['space.read', 'tweet.read', 'users.read'],
                    
                }
                
            ],
            
            
            ...requestOptions
            
        };

        return this.client.request<GetPostsResponse>(
            'GET',
            path + (params.toString() ? `?${params.toString()}` : ''),
            finalRequestOptions
        );
    }




  /**
   * Search Spaces
   * Retrieves a list of Spaces matching the specified search query.



   * @param query The search query.



   * @returns {Promise<SearchResponse>} Promise resolving to the API response
   */
    // Overload 1: Default behavior (unwrapped response)
    async search(
        
        
        
        
        
        query: string,
        
        
        
        
        
        
        options: SearchOptions = {}
        
    ): Promise<SearchResponse> {
        // Normalize options to handle both camelCase and original API parameter names
        
        
        const paramMappings: Record<string, string> = {
            
            
            
            
            'max_results': 'maxResults',
            
            
            
            'space.fields': 'spaceFields',
            
            
            
            
            
            'user.fields': 'userFields',
            
            
            
            'topic.fields': 'topicFields',
            
            
        };
        const normalizedOptions = this._normalizeOptions(options || {}, paramMappings);
        
        
        // Destructure options (exclude path parameters, they're already function params)
        const {
            
            
            state = undefined,
            
            
            
            maxResults = undefined,
            
            
            
            spaceFields = [],
            
            
            
            expansions = [],
            
            
            
            userFields = [],
            
            
            
            topicFields = [],
            
            
            
            requestOptions: requestOptions = {}
        } = normalizedOptions;
        

        // Build the path with path parameters
        let path = '/2/spaces/search';
        

        // Build query parameters
        const params = new URLSearchParams();
        
        
        
        
        if (query !== undefined) {
            
            params.append('query', String(query));
            
        }
        
        
        
        
        
        
        if (state !== undefined) {
            
            params.append('state', String(state));
            
        }
        
        
        
        
        
        
        if (maxResults !== undefined) {
            
            params.append('max_results', String(maxResults));
            
        }
        
        
        
        
        
        
        if (spaceFields !== undefined && spaceFields.length > 0) {
            
            params.append('space.fields', spaceFields.join(','));
            
        }
        
        
        
        
        
        
        if (expansions !== undefined && expansions.length > 0) {
            
            params.append('expansions', expansions.join(','));
            
        }
        
        
        
        
        
        
        if (userFields !== undefined && userFields.length > 0) {
            
            params.append('user.fields', userFields.join(','));
            
        }
        
        
        
        
        
        
        if (topicFields !== undefined && topicFields.length > 0) {
            
            params.append('topic.fields', topicFields.join(','));
            
        }
        
        
        

        // Prepare request options
        const finalRequestOptions: RequestOptions = {
            
            
            // Pass security requirements for smart auth selection
            security: [
                
                {
                    
                    'BearerToken': [],
                    
                },
                
                {
                    
                    'OAuth2UserToken': ['space.read', 'tweet.read', 'users.read'],
                    
                }
                
            ],
            
            
            ...requestOptions
            
        };

        return this.client.request<SearchResponse>(
            'GET',
            path + (params.toString() ? `?${params.toString()}` : ''),
            finalRequestOptions
        );
    }




  /**
   * Get space by ID
   * Retrieves details of a specific space by its ID.


   * @param id The ID of the Space to be retrieved.




   * @returns {Promise<GetByIdResponse>} Promise resolving to the API response
   */
    // Overload 1: Default behavior (unwrapped response)
    async getById(
        
        
        
        id: string,
        
        
        
        
        
        
        
        
        options: GetByIdOptions = {}
        
    ): Promise<GetByIdResponse> {
        // Normalize options to handle both camelCase and original API parameter names
        
        
        const paramMappings: Record<string, string> = {
            
            
            'space.fields': 'spaceFields',
            
            
            
            
            
            'user.fields': 'userFields',
            
            
            
            'topic.fields': 'topicFields',
            
            
        };
        const normalizedOptions = this._normalizeOptions(options || {}, paramMappings);
        
        
        // Destructure options (exclude path parameters, they're already function params)
        const {
            
            
            spaceFields = [],
            
            
            
            expansions = [],
            
            
            
            userFields = [],
            
            
            
            topicFields = [],
            
            
            
            requestOptions: requestOptions = {}
        } = normalizedOptions;
        

        // Build the path with path parameters
        let path = '/2/spaces/{id}';
        
        
        path = path.replace('{id}', encodeURIComponent(String(id)));
        
        

        // Build query parameters
        const params = new URLSearchParams();
        
        
        
        
        if (spaceFields !== undefined && spaceFields.length > 0) {
            
            params.append('space.fields', spaceFields.join(','));
            
        }
        
        
        
        
        
        
        if (expansions !== undefined && expansions.length > 0) {
            
            params.append('expansions', expansions.join(','));
            
        }
        
        
        
        
        
        
        if (userFields !== undefined && userFields.length > 0) {
            
            params.append('user.fields', userFields.join(','));
            
        }
        
        
        
        
        
        
        if (topicFields !== undefined && topicFields.length > 0) {
            
            params.append('topic.fields', topicFields.join(','));
            
        }
        
        
        

        // Prepare request options
        const finalRequestOptions: RequestOptions = {
            
            
            // Pass security requirements for smart auth selection
            security: [
                
                {
                    
                    'BearerToken': [],
                    
                },
                
                {
                    
                    'OAuth2UserToken': ['space.read', 'tweet.read', 'users.read'],
                    
                }
                
            ],
            
            
            ...requestOptions
            
        };

        return this.client.request<GetByIdResponse>(
            'GET',
            path + (params.toString() ? `?${params.toString()}` : ''),
            finalRequestOptions
        );
    }




  /**
   * Get Spaces by creator IDs
   * Retrieves details of Spaces created by specified User IDs.



   * @param userIds The IDs of Users to search through.



   * @returns {Promise<GetByCreatorIdsResponse>} Promise resolving to the API response
   */
    // Overload 1: Default behavior (unwrapped response)
    async getByCreatorIds(
        
        
        
        
        
        userIds: Array<any>,
        
        
        
        
        
        
        options: GetByCreatorIdsOptions = {}
        
    ): Promise<GetByCreatorIdsResponse> {
        // Normalize options to handle both camelCase and original API parameter names
        
        
        const paramMappings: Record<string, string> = {
            
            
            'space.fields': 'spaceFields',
            
            
            
            
            
            'user.fields': 'userFields',
            
            
            
            'topic.fields': 'topicFields',
            
            
        };
        const normalizedOptions = this._normalizeOptions(options || {}, paramMappings);
        
        
        // Destructure options (exclude path parameters, they're already function params)
        const {
            
            
            spaceFields = [],
            
            
            
            expansions = [],
            
            
            
            userFields = [],
            
            
            
            topicFields = [],
            
            
            
            requestOptions: requestOptions = {}
        } = normalizedOptions;
        

        // Build the path with path parameters
        let path = '/2/spaces/by/creator_ids';
        

        // Build query parameters
        const params = new URLSearchParams();
        
        
        
        
        if (userIds !== undefined && userIds.length > 0) {
            
            params.append('user_ids', userIds.join(','));
            
        }
        
        
        
        
        
        
        if (spaceFields !== undefined && spaceFields.length > 0) {
            
            params.append('space.fields', spaceFields.join(','));
            
        }
        
        
        
        
        
        
        if (expansions !== undefined && expansions.length > 0) {
            
            params.append('expansions', expansions.join(','));
            
        }
        
        
        
        
        
        
        if (userFields !== undefined && userFields.length > 0) {
            
            params.append('user.fields', userFields.join(','));
            
        }
        
        
        
        
        
        
        if (topicFields !== undefined && topicFields.length > 0) {
            
            params.append('topic.fields', topicFields.join(','));
            
        }
        
        
        

        // Prepare request options
        const finalRequestOptions: RequestOptions = {
            
            
            // Pass security requirements for smart auth selection
            security: [
                
                {
                    
                    'BearerToken': [],
                    
                },
                
                {
                    
                    'OAuth2UserToken': ['space.read', 'tweet.read', 'users.read'],
                    
                }
                
            ],
            
            
            ...requestOptions
            
        };

        return this.client.request<GetByCreatorIdsResponse>(
            'GET',
            path + (params.toString() ? `?${params.toString()}` : ''),
            finalRequestOptions
        );
    }

















}
